// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Lithuania from '../_raw/flag/icon_flag_lithuania.png';

export default () => <img src={Lithuania} alt="Lithuania" />;
